var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraIcon2 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6851 0.646484L4.60778 2.80114H2.0222C0.947885 2.80114 0.0830078 3.66601 0.0830078 4.74032V11.6352C0.0830078 12.7095 0.947885 13.5744 2.0222 13.5744H13.6573C14.7316 13.5744 15.5965 12.7095 15.5965 11.6352V4.74032C15.5965 3.66601 14.7316 2.80114 13.6573 2.80114H11.0717L9.99441 0.646484H5.6851ZM7.83976 5.17126C9.50573 5.17126 10.8563 6.52178 10.8563 8.18777C10.8563 9.85375 9.50573 11.2043 7.83976 11.2043C6.17382 11.2043 4.82324 9.85375 4.82324 8.18777C4.82324 6.52178 6.17382 5.17126 7.83976 5.17126Z",
    fill: "#DDE2EB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraIcon2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cameraIcon2.c5ae1ac84cf210567e49d4de801b0700.svg";